
//お気に入りページのリストクリック時にモーダルを介さずに商品詳細に遷移させる
document.body.addEventListener('click', function(e) {
  const link = e.target.closest('a.custom-view-detail-wrapper');

  // aタグの中の「カートに追加」ボタンを押したときはスルー
  if (link && !e.target.closest('.swym-add-to-cart-btn') && !e.target.closest('.swym-delete-btn')) {
    console.log('Blocked Swym modal popup (link only)');
    e.stopImmediatePropagation(); // Swymのモーダルをブロック
  }
}, true);

document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(() => {
    const listItems = document.querySelectorAll('.swym-wishlist-grid li');

    listItems.forEach(li => {
      if (li.querySelector('.custom-view-detail-wrapper')) return;

      const wishlistItem = li.querySelector('.swym-wishlist-item');
      const img = li.querySelector('img');
      const addToCartBtn = li.querySelector('.swym-add-to-cart-btn');
      const deleteBtn = li.querySelector('.swym-delete-btn');
      
      if (!wishlistItem || !img || !img.src) return;
      
      // 画像ファイル名だけから商品IDを取得
      const filename = img.src.split('/').pop().split('?')[0]; // 末尾ファイル名を取得
      const match = filename.match(/^([\w\d]+)-/i); // 最初のハイフン前までマッチ
      if (!match || !match[1]) return;
      
      const productId = match[1].toLowerCase();
      const productUrl = `/products/${productId}`;

      // <a>タグを作成
      const link = document.createElement('a');
      link.href = productUrl;
      link.className = 'custom-view-detail-wrapper';
      link.style.display = 'block';
      link.style.textDecoration = 'none';
      link.style.color = 'inherit';

      // wishlistItemを<a>でラップ（カートボタン含む）
      wishlistItem.parentNode.insertBefore(link, wishlistItem);
      link.appendChild(wishlistItem);

      // aタグ内クリック時、カートボタン以外なら商品ページに飛ばす
      link.addEventListener('click', (e) => {
        if (!e.target.closest('.swym-add-to-cart-btn') && !e.target.closest('.swym-delete-btn')) {
          e.preventDefault();
          e.stopImmediatePropagation();
          window.location.href = productUrl;
        }
      });

      // お気に入り削除ボタンがクリックされたとき、削除処理を実行する
      if (deleteBtn) {
        deleteBtn.addEventListener('click', (e) => {
          console.log('🗑️ お気に入り削除ボタンがクリックされました');
          e.stopPropagation(); // 他のクリックイベントが発生しないように
          // Swymの削除機能がちゃんと動くように
        });
      }

      // li全体でSwymのモーダルトリガーを阻止（カート追加ボタン以外）
      li.addEventListener('click', (e) => {
        if (!e.target.closest('.swym-add-to-cart-btn') && !e.target.closest('.swym-delete-btn')) {
          e.stopPropagation();
          e.preventDefault();
        }
      });
      
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});
